import { render, staticRenderFns } from "./AdminTabs.vue?vue&type=template&id=218e27ac&"
import script from "./AdminTabs.vue?vue&type=script&lang=js&"
export * from "./AdminTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports